export default __webpack_public_path__ + "static/media/oxlade.e61da2b3.png";